import { Row, Rows } from 'common/types/scalarSpreadsheet';
import {
  PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
  SHEET_ALIASES_CONSTANTS,
  SHEET_TITLES_CONSTANTS,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics';
import { generateColumnKey, getArrayValue, getStringValue } from 'utillities';
import { ComparisonCompaniesParams, RowConfigCalibrationParams } from './types';

const comparisonCompanies = (params: ComparisonCompaniesParams): Rows => {
  const { gpcComparison } = params;

  return getArrayValue(
    gpcComparison
      ?.filter(comparison => comparison.name !== '0')
      .map(
        comparison =>
          ({
            alias: generateColumnKey({
              name: getStringValue(comparison.cap_iq_id ?? comparison?.name ?? comparison?.company_name ?? ''),
              prefix: PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
            }),
            gridType: 'string',
            ignoreRowCopy: true,
            readOnly: true,
            className: 'row-label-indented',
            value: getStringValue(comparison?.name || comparison?.company_name),
            isClassNameRequired: true,
          } as Row)
      )
  );
};

const rowConfigCalibrationPerformance = (params: RowConfigCalibrationParams): Rows => {
  const { valuationsApproachGpc } = params;
  const { gpcComparisonByDate } = params;
  let gpcComparison = getArrayValue(valuationsApproachGpc?.gpc_comparison);

  if (gpcComparisonByDate !== undefined) {
    gpcComparison = gpcComparisonByDate;
  }

  return [
    {
      alias: SHEET_ALIASES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_HEADER_TITLE,
      className: 'table-header full-width-label',
      gridType: 'string',
      ignoreRowCopy: true,
      isParentWithDivider: false,
      readOnly: true,
      rowSpan: 1,
      columnSpan: 2,
      value: SHEET_TITLES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_HEADERS[0].value,
      isTitleOrHeader: true,
    } as Row,
    ...(gpcComparison.length > 0 ? comparisonCompanies({ gpcComparison }) : []),
  ];
};

export default rowConfigCalibrationPerformance;
